import { Switch, styled } from '@mui/material';
import type { ChangeEvent } from 'react';

interface Props {
    name?: string;
    checked?: boolean;
    onChange(event: ChangeEvent<HTMLInputElement>): void;
    disabled?: boolean;
}

const StyledSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
    '& .Mui-disabled': {
        opacity: 0.8,
    },
    '&:active': {
        '& .MuiSwitch-thumb': {
            width: 15,
        },
        '& .MuiSwitch-switchBase.Mui-checked': {
            transform: 'translateX(9px)',
        },
    },
    '& .MuiSwitch-switchBase': {
        padding: 2,
        transform: 'translateX(2px) translateY(1px)',
        color: '#7B7D80',
        '&.Mui-checked': {
            transform: 'translateX(12px) translateY(1px)',
            color: '#fff',
            '& .MuiSwitch-thumb': {
                backgroundColor: '#fff',
            },
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: theme.palette.primary.main,
                border: 'none', // remove border when switch is on
            },
        },
    },
    // When checked AND disabled, make the track less opaque
    '& .MuiSwitch-switchBase.Mui-checked.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.4,
    },
    '& .MuiSwitch-thumb': {
        boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
        width: 10,
        height: 10,
        borderRadius: 6,
        backgroundColor: '#7B7D80',
        transition: theme.transitions.create(['width'], {
            duration: 200,
        }),
    },
    '& .MuiSwitch-track': {
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor: '#ffffff',
        boxSizing: 'border-box',
        border: '2px solid #7B7D80', // add border when switch is off Neutral 500
    },
}));

export default function LexoSwitch({ checked, onChange, name, disabled }: Props) {
    return <StyledSwitch checked={checked} onChange={onChange} name={name} disabled={disabled} />;
}
